import React from 'react';
import { css } from 'emotion';
import { AccessibleErrorContainer } from 'client/components/AccessibleErrorContainer';

const AdsLoadingErrorBanner = ({
  onClickReload,
}: {
  onClickReload?: () => void;
}) => {
  return (
    <AccessibleErrorContainer
      className={css`
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 12px 0 0;
        color: #9a201c;
      `}
    >
      An error has occurred
      {onClickReload && (
        <button
          type="button"
          aria-label="click to reload ads"
          className={css`
            text-decoration: underline;
          `}
          onClick={onClickReload}
        >
          reload ads
        </button>
      )}
    </AccessibleErrorContainer>
  );
};

export { AdsLoadingErrorBanner };
